/**
 * Copy for Home (Today) hero — contextual, no fake tournament data.
 */

/**
 * @returns {'morning' | 'afternoon' | 'evening'}
 */
export function timeOfDayBucket(date = new Date()) {
  const h = date.getHours();
  if (h < 12) return "morning";
  if (h < 17) return "afternoon";
  return "evening";
}

/**
 * @param {string} [displayName]
 */
export function greetingLine(displayName) {
  const bucket = timeOfDayBucket();
  const label =
    bucket === "morning" ? "Good morning" : bucket === "afternoon" ? "Good afternoon" : "Good evening";
  const who = (displayName || "Player").trim() || "Player";
  return `${label}, ${who}`;
}

/**
 * @param {{ hasResumableSession?: boolean }} ctx
 */
export function heroHeadline(_ctx = {}) {
  return "Ready for your next rally?";
}
